module.exports = __webpack_public_path__ + "img/Betting_text05b_allow.fe2e90c3.png";